import { gql } from 'graphql-tag'
import queryPageFields from '#layers/core/data-layer/pages/page/query-page-fields.js'
import { fragmentModuleChapter } from '#layers/core/data-layer/modules/fragments'

export default gql`
  ${fragmentModuleChapter}
  query($slug: String! = "", $sysId: String! = "", $locale: String!, $withParent: Boolean! = false, $slugParent: String! = "", $preview: Boolean!) {
    page: pagePrivacyPolicyDetailCollection(limit: 1, where: { OR: [{ sys: { id: $sysId }}, { slug: $slug }]}, locale: $locale, preview: $preview) {
      items {
        ${queryPageFields}
        defaultLocaleFallbackEnabled
        introText {
          json
        }
        numberedDocument
        chaptersCollection(limit: 20) {
          items {
            ...ModuleChapterFragment
          }
        }
        icon
        navigationTitle
        navigationDescription
      }
    }
    pageParent: pagePrivacyPolicyCollection(limit: 1, where: { slug: $slugParent }, locale: $locale, preview: $preview) @include(if: $withParent) {
      items {
        sys {
          id
        }
        title
        itemsCollection {
          items {
             sys {
              id
            }
            navigationTitle
          }
        }
      }
    }
  }
`
